module.exports = __webpack_public_path__ + "static/img/GoChat-beta.497aa97.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/GoChat-beta.png
// module id = Oxom
// module chunks = 31